<script>import { goto } from "$app/navigation";
import { menuAutoCollapsed } from "../state";
import { cfgToThemeCdnPath, stateUi } from "@infinitro/config";
import { isMobile, toSiteUrl } from "@infinitro/global";
$: bannerSrc = (() => {
  if ($isMobile) return cfgToThemeCdnPath("/sidebar/banner/banner-mobile.png");
  if ($menuAutoCollapsed) return cfgToThemeCdnPath("/sidebar/banner/banner-collapsed.png");
  return cfgToThemeCdnPath("/sidebar/banner/banner.png");
})();
</script>

<div class="banner" on:click={() => goto(toSiteUrl($stateUi.sidebar.bannerLink ?? ''))}>
	<img src={bannerSrc} alt="Banner" />
</div>

<style>
	.banner {
		width: 100%;
		cursor: pointer
}

	.banner img {
		position: relative;
		right: -1px;
		height: auto;
		width: 100%;
		-o-object-fit: contain;
		   object-fit: contain;
		transform: scale(1.04)
}

	@media (min-width: 1024px) {
		.banner img {
				inset: 0px;
			transform: scale(1.05)
		}
	}
</style>
